"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impactValues = exports.igtValues = exports.guidedToolsInOrder = exports.configAdvancedRulesValues = exports.configBestPracticesValues = exports.configNeedsReviewValues = exports.deprecatedIgtTools = void 0;
// TODO: we are currently maintaining this list in multiple places. We should add a property in `manifest` to indicate whether a guide tool is deprecated or not instead.
exports.deprecatedIgtTools = [
    'page-info',
    'buttons-and-links',
    'lists',
    'headings'
];
exports.configNeedsReviewValues = [
    'enabled',
    'disabled',
    'exclude'
];
exports.configBestPracticesValues = ['enabled', 'disabled'];
exports.configAdvancedRulesValues = ['enabled', 'disabled'];
exports.guidedToolsInOrder = [
    'table',
    'keyboard',
    'aria-modal',
    'interactive-elements',
    'structure',
    'page-info', // DEPRECATED!
    'buttons-and-links', // DEPRECATED!
    'lists', // DEPRECATED!
    'images',
    'headings', // DEPRECATED!
    'forms'
];
exports.igtValues = [...exports.guidedToolsInOrder, 'all'];
exports.impactValues = [
    'critical',
    'serious',
    'moderate',
    'minor'
];
//# sourceMappingURL=types.js.map